import {AfterViewInit, Component, ElementRef, Input, OnInit, SimpleChange, ViewChild} from '@angular/core';
import {PointOfSaleDto} from "../../point-of-sale-dto";
import {LoggerService} from "../../../../core/logger.service";
import {ModalService} from "../../../../root/modal/modal.service";
import {TranslateService} from "@ngx-translate/core";
import {AirportCodeEnum} from "../../airport-code.enum";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'miami-indications-pos',
    templateUrl: './miami-indications-pos.component.html',
    providers: []
})
export class MiamiIndicationsPosComponent implements OnInit, AfterViewInit{

    errors:any={};
    @Input() dto:PointOfSaleDto;
    @Input() isPointOfSale:boolean;
    @ViewChild('defaultInstructionsDescription') description:ElementRef;
    name: string = "default-instructions";
    title: string = "";
    openModal:boolean=false;
    meetingType:string[]=['COUNTER','MEET_AND_GREET','RENTAL_SHUTTLE','AIRPORT_SHUTTLE'];
    native:any;
    previousMeetingType:string = "";

    constructor(private modalService: ModalService,
                private logger: LoggerService,
                private translate: TranslateService) {
        logger.info('Default instructions: logger.info()');
    }

    ngOnInit(): void {
        if(!this.dto.pickupIndications){
            this.dto.pickupIndications = {meetingType:""};
        }

        this.modalService.change.subscribe(info => {
            if(this.dto.pickupIndications){
                this.dto.pickupIndications.additionalInstructions = info.additionalInstructions;
                this.dto.pickupIndications.meetingType = info.meetingType;
                this.setDescription(this.dto.pickupIndications.meetingType);
            }
        });
    }

    ngAfterViewInit(): void {
        if(this.dto.pickupIndications){
            this.setDescription(this.dto.pickupIndications.meetingType);
        }
    }

    addGreenBorder(type) {
        return this.dto.pickupIndications && this.dto.pickupIndications.meetingType === type;
    }

    getAdditionalInstructionModal(type){
        let title = "ADDITIONAL_INSTRUCTIONS."+type+".TITLE";
        let label = "ADDITIONAL_INSTRUCTIONS."+type+".LABEL";
        let description="ADDITIONAL_INSTRUCTIONS.DESCRIPTION";
        this.modalService.showAdditionalPickupPointModal(title, description,label, this.dto.pickupIndications.additionalInstructions, type,true);
    }

    setDescription(type):string {
        this.previousMeetingType = type;
        console.log("previous" + this.previousMeetingType);
        if (!this.dto.pickupIndications.additionalInstructions){
            return ""; //Dont show description when there aren't additional instructions
        }
        let tradeName = JSON.parse(localStorage.getItem("company")).tradeName;
        let key = "modal.ADDITIONAL_INSTRUCTIONS."+type+".LABEL";
        document.getElementById("default-instruction-description-"+type).innerHTML = this.translate.instant(key).replace("{{tradeName}}",tradeName).replace(":","")+ " <b>" + this.dto.pickupIndications.additionalInstructions + "</b>";
        document.getElementById("default-instruction-description-"+type).className="default-instruction-sumary";
    }

    isDisabled() {
      return this.dto.pickupIndications.meetingType === 'COUNTER' ||
        this.dto.pickupIndications.meetingType === 'MEET_AND_GREET' ||
        this.dto.pickupIndications.meetingType === 'RENTAL_SHUTTLE' ||
        this.dto.pickupIndications.meetingType === 'AIRPORT_SHUTTLE';
      }

    isHidden(type){
        return this.dto.pickupIndications && this.dto.pickupIndications.meetingType !== type;
    }

    selectClick(type){
        this.dto.pickupIndications.additionalInstructions = "";
        this.getAdditionalInstructionModal(type);
    }

    editClick(type){
        this.getAdditionalInstructionModal(type);
    }

    clear(type){
        this.dto.pickupIndications.meetingType=null;
        this.dto.pickupIndications.additionalInstructions="";
        document.getElementById("default-instruction-description-"+type).innerHTML = "";
        document.getElementById("default-instruction-description-"+type).className="";
    }

    isCounter(type) {
        return type ==='COUNTER'
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/delivery-instructions/miami-indications-pos/miami-indications-pos.component.ts